import { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { ThemeProvider } from '@material-ui/core/styles';
import theme from "./common/theme";
import ScrollToTop from "./common/ScrollToTop";
import Homepage from "./homepage/Homepage";
import Menu from './menu/Menu';
import BeveragesMenu from './menu/BeveragesMenu';
import NavBar from "./common/NavBar";
import Footer from "./common/footer";
import AboutUs from "./aboutUs/AboutUs";
import Services from "./services/Services";
import PageNotFound from "./PageNotFound";
import './App.css';
import "@fontsource/galada"

function App() {
  const [shrinkHeader, setShrinkHeader] = useState(false);

  const resizeHeaderOnScroll = () => {
    if (window.pageYOffset > 50) {
      return setShrinkHeader(true);
    } return setShrinkHeader(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", resizeHeaderOnScroll);
  });

  return (
    <div className='app-container'>
      <ThemeProvider theme={theme}>
        <Router>
          <ScrollToTop />
          <NavBar shrinkHeader={shrinkHeader} />
          <Switch>
            <Route path="/" exact>
              <Homepage />
            </Route>

            <Route path="/menu/beverages">
              <BeveragesMenu />
            </Route>
            <Route path="/menu">
              <Menu />
            </Route>

            <Route path="/about-us">
              <AboutUs />
            </Route>
            <Route path="/services">
              <Services />
            </Route>

            <Route path="*">
              <PageNotFound />
            </Route>

            {/*TODO: 404*/}
          </Switch>
          <Footer />
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
